<template>
    <v-row justify="start" align="start" no-gutters class="custom-footer px-2 py-2" :style="'padding-left: 18px; padding-right: 18px;'" style="background-color: #ececec;">
        <v-col align="start" cols=12 lg="4">
            <v-row>
                <v-col cols=12>
                    <h4>Επικοινωνία</h4>
                </v-col>
            </v-row>
            <v-row style="font-size: 16px;">
                <v-col cols=12>
                    <v-icon color="white">
                        mdi-map-marker
                    </v-icon>
                    <span class="px-2">
                        <a :href="addressUrl">
                            {{language=='Ελληνικά'? this.contact.address : 'Leoforos Amfitheas 167 & Metsovou 2, P. Faliro, 175 63'}}
                        </a>
                    </span>
                </v-col>
            </v-row>
            <v-row style="font-size: 16px;">
                <v-col cols="12">
                    <a href="tel:+302109852175">
                        <v-icon color="white">
                            mdi-phone
                        </v-icon>
                        <span class="px-2">
                            {{this.contact.phone}}
                        </span>
                    </a>
                </v-col>
                <v-col cols="12">
                    <a href="tel:+306940465584">
                        <v-icon color="white">
                            mdi-phone
                        </v-icon>
                        <span class="px-2">
                            {{this.contact.mobile}}
                        </span>
                    </a>
                </v-col>
                <v-col cols="12">
                    <a href="mailto:contact@paron-card.gr">
                        <v-icon color="white">
                            mdi-email
                        </v-icon>
                        <span class="px-2">
                            {{this.contact.mail}}
                        </span>
                    </a>
                </v-col>
                <v-col cols="12">
                    <v-btn
                        icon
                        href="https://www.youtube.com/channel/UC4E83cf5r0kA5768eU7ArZQ"
                        target="_blank"
                    >
                        <v-icon color="white">
                            mdi-youtube
                        </v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        href="https://www.facebook.com/profile.php?id=100085421851501"
                        target="_blank"
                    >
                        <v-icon class="pl-2" color="white">
                            mdi-facebook
                        </v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        href="https://www.instagram.com/paroncard/ "
                        target="_blank"
                    >
                        <v-icon class="pl-2" color="white">
                            mdi-instagram
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col align="start" cols=12 lg="4">
            <v-row>
                <v-col cols=12>
                    <h4>Χρήσιμα</h4>
                </v-col>
            </v-row>
            <v-row style="font-size: 16px;">
                <v-col cols="12">
                    <router-link to="/PrivacyPolicy">
                        <span class="px-2" style="cursor: pointer;" @click="$router.push({name: 'PrivacyPolicy'})">
                            Πολιτική απορρήτου
                        </span>
                    </router-link>
                </v-col>
            </v-row>
            <v-row style="font-size: 16px;">
                <v-col cols="12">
                    <router-link to="/Terms">
                        <span class="px-2" style="cursor: pointer;" @click="$router.push({name: 'Terms'})">
                            Όροι χρήσης κάρτας
                        </span>
                    </router-link>
                </v-col>
            </v-row>
        </v-col>
        <v-col align="start" cols=12 lg="4">
            <v-row>
                <v-col cols=12>
                    <h4>PARON CARD APP</h4>
                </v-col>
            </v-row>
            <v-row style="font-size: 28px;">
                <v-col cols=12>
                    Κατέβασε την εφαρμογή
                </v-col>
            </v-row>
            <v-row style="font-size: 15px;" class="py-0 my-0">
                <v-col cols=12 class="py-0 my-0" style="cursor: pointer;">
                    <v-img
                        width="130px"
                        contain
                        :src="require('@/assets/app-store.png')"
                        style="display: inline-block;"
                        class="pt-5"
                        @click="openTab('apple')"
                    />
                    <v-img
                        width="150px"
                        contain
                        :src="require('@/assets/google-play.png')"
                        style="display: inline-block;"
                        @click="openTab('google')"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

export default {
   data() {
       return {
            addressUrl: 'https://www.google.com/maps/place/Leof.+Amfitheas+167,+2,+Paleo+Faliro+175+63/@37.9244304,23.7026248,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bc2f414ad4cd:0xd053af443c079526!8m2!3d37.9244304!4d23.7051997?authuser=0&entry=ttu',
            contact: {
                address: "Λεωφόρος Αμφιθέας 167 & Μετσόβου 2, Π.Φάληρο, 175 63, 3ος όροφος",
                mail:"contact@paron-card.gr",
                phone: "(+30) 210 9852175",
                mobile: "(+30) 6940 465 584"
            }
       }
    },
    computed: {
        language() {
            return this.$store.getters.getLanguage.language
        }
    },
    methods: {
        openTab(platform) {
            if (platform === 'google' ) {
                window.open('https://google.gr', '_blank')
            } else {
                window.open('https://google.gr', '_blank')
            }
        }
    }
}
</script>

<style scoped>
    .custom-footer{ 
        color: white;
        background: url('../assets/footer.jpg'), #1b2f5a;
        background-size: cover;
        background-repeat: no-repeat;
        height: auto;
    }

    a {
        color: white !important; /* blue colors for links too */
        text-decoration: none; /* no underline */
    }
</style>